import { Navigate, useParams, useSearchParams, type RouteObject } from "react-router";
import { Unterschreiben } from "./Unterschreiben";

/** Vertrag per Link unterschreiben (Mail-Link: /unterschreiben?t=<token>, 0026). */
function AlterWeg() {
  const { token } = useParams();
  return <Navigate to={`/unterschreiben?t=${encodeURIComponent(token ?? "")}`} replace />;
}

/** Ein anderer Link im selben Tab (Demo, Verlauf) startet die Seite neu, statt den Stand des vorigen Links zu zeigen. */
function SeiteJeLink() {
  const [params] = useSearchParams();
  return <Unterschreiben key={params.get("t") ?? ""} />;
}

export const unterschreibenRoutes: RouteObject[] = [
  { path: "/unterschreiben", element: <SeiteJeLink /> },
  { path: "/s/:token", element: <AlterWeg /> },
];
